<template>
  <div class="container-md overflow-auto" style="padding: 60px 14px;">
    <!-- body -->
    <div
      class="row justify-content-center"
      v-if="isLoading || initEventLoading"
    >
      <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
    </div>
    <b-row v-else>
      <b-col></b-col>
      <b-col cols="10">
        <template v-if="errorMessage">
          <div class="d-flex flex-column align-items-center">
            <b-icon
              icon="exclamation-triangle"
              variant="danger"
              style="width: 120px; height: 120px;"
            ></b-icon>
            <p class="h3">{{ errorMessage }}</p>
          </div>
        </template>
        <template v-else>
          <div class="d-flex flex-column">
            <div class="row justify-content-center" v-if="paymentCreating">
              <b-icon
                icon="three-dots"
                animation="cylon"
                font-scale="4"
              ></b-icon>
            </div>
            <template v-else>
              <template v-if="!showPaymentResultSection">
                <b-row>
                  <div class="col-12">
                    <h6>
                      {{ $t("PAGES.SALES_MANAGEMENT.LINK_SALES.ORDER_INFO") }}
                    </h6>
                  </div>
                </b-row>
                <div class="row justify-content-center" v-if="orderCreating">
                  <b-icon
                    icon="three-dots"
                    animation="cylon"
                    font-scale="4"
                  ></b-icon>
                </div>
                <b-row class="mb-5" v-else>
                  <div class="col-12 col-md-4">
                    <label class="col-form-label font-weight-bold"
                      >{{
                        $t("PAGES.SALES_MANAGEMENT.LINK_SALES.ORDER_IDENTITY")
                      }}:</label
                    >
                    <span class="ml-2">{{ getOrderNumber }}</span>
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="col-form-label font-weight-bold"
                      >{{
                        $t("PAGES.SALES_MANAGEMENT.LINK_SALES.ORDER_AMOUNT")
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ getPrice }} {{ selectedPaymentUnit }}</span
                    >
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="col-form-label font-weight-bold"
                      >{{
                        $t(
                          "PAGES.SALES_MANAGEMENT.LINK_SALES.COMMISSION_AMOUNT"
                        )
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ getFee }}% ({{ feeAmount }}
                      {{ selectedPaymentUnit }})</span
                    >
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="col-form-label font-weight-bold"
                      >{{
                        $t("PAGES.SALES_MANAGEMENT.LINK_SALES.TOTAL_AMOUNT")
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ totalAmount }} {{ selectedPaymentUnit }}</span
                    >
                  </div>
                  <div class="col-12 col-md-4" v-if="totalQuantity">
                    <label class="col-form-label font-weight-bold"
                      >{{
                        $t("PAGES.SALES_MANAGEMENT.LINK_SALES.TOTAL_QUANTITY")
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ totalQuantity }}
                      <template v-if="selectedCryptoCode">
                        {{ selectedCryptoCode }}
                      </template>
                    </span>
                  </div>
                  <div class="col-12 col-md-4" v-if="nonUserOrderWalletAddress">
                    <label class="col-form-label font-weight-bold"
                      >{{
                        $t("PAGES.SALES_MANAGEMENT.LINK_SALES.WALLET")
                      }}:</label
                    >
                    <span class="ml-2">{{ nonUserOrderWalletAddress }} </span>
                  </div>
                  <div class="col-12" v-if="showCustomerInfo">
                    <div class="bg-secondary" style="height: 2px;"></div>
                  </div>
                  <div class="col-12 mt-3" v-if="showCustomerInfo">
                    <h6>
                      {{
                        $t(
                          "PAGES.SALES_MANAGEMENT.QR_SALE.NEW_SALE_WITH_QR_CODE.CUSTOMER_INFO"
                        )
                      }}
                    </h6>
                  </div>
                  <div
                    class="col-12 col-md-4"
                    v-if="createOrderForm.customerMail"
                  >
                    <label class="col-form-label font-weight-bold"
                      >{{
                        `${$t("PAGES.SALES_MANAGEMENT.LIST.CUSTOMER")} ${$t(
                          "FORM.EMAIL"
                        )}`
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ createOrderForm.customerMail }}
                    </span>
                  </div>
                  <div
                    class="col-12 col-md-4"
                    v-if="createOrderForm.customerName"
                  >
                    <label class="col-form-label font-weight-bold"
                      >{{
                        `${$t("PAGES.SALES_MANAGEMENT.LIST.CUSTOMER")} ${$t(
                          "FORM.FIRST_NAME"
                        )}`
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ createOrderForm.customerName }}
                    </span>
                  </div>
                  <div
                    class="col-12 col-md-4"
                    v-if="createOrderForm.customerPhone"
                  >
                    <label class="col-form-label font-weight-bold"
                      >{{
                        `${$t("PAGES.SALES_MANAGEMENT.LIST.CUSTOMER")} ${$t(
                          "FORM.PHONE"
                        )}`
                      }}:</label
                    >
                    <span class="ml-2"
                      >{{ createOrderForm.customerPhone }}
                    </span>
                  </div>
                </b-row>
                <b-row class="mb-4">
                  <currency-selector
                    v-if="!cryptosLoading && !getCryptoFromQueryParam"
                    v-on:currency-selected="onCryptoSelected"
                    :currencies="cryptos"
                    :selectedCurrency="selectedCrypto"
                    :containerClass="
                      getPaymentUnitFromQueryParam
                        ? 'col-12'
                        : 'col-12 col-md-6 col-md'
                    "
                  ></currency-selector>
                  <div
                    class="col-12 col-md-6 mt-4 mt-md-0"
                    v-if="!getPaymentUnitFromQueryParam"
                  >
                    <template>
                      <input
                        v-if="paymentUnitsLoading"
                        type="text"
                        class="form-control"
                        :class="{ 'bg-dark text-white': isDark }"
                        placeholder="Loading..."
                        disabled
                      />
                      <b-form-select
                        v-else
                        v-model="selectedPaymentUnit"
                        :options="paymentUnits"
                        text-field="label"
                        value-field="name"
                        @change="onChangePaymentUnit"
                        class="border-primary text-primary text-center"
                        :class="[isDark ? 'bg-dark' : 'bg-transparent']"
                      >
                        <!-- This slot appears above the options from 'options' prop -->
                        <template #first>
                          <b-form-select-option :value="null">{{
                            $t("FORM.SELECT_A_PAYMENT_UNIT")
                          }}</b-form-select-option>
                        </template>
                      </b-form-select>
                    </template>
                  </div>
                </b-row>
                <b-row>
                  <div
                    :class="[
                      getPaymentUnitFromQueryParam
                        ? 'col-12'
                        : 'col-12 col-md-6'
                    ]"
                  >
                    <b-button
                      variant="success"
                      block
                      class="d-inline-flex justify-content-center align-items-center"
                      :disabled="!selectedCrypto || !selectedPaymentUnit"
                      @click="onClickNonMcmUser"
                    >
                      <div
                        class="mr-2 font-weight-bold"
                        style="font-family: 'Poppins', sans-serif;"
                      >
                        Pay with
                      </div>
                      <img
                        :src="require('@/assets/images/mpay-btn.png')"
                        alt="mpay"
                        style="max-height: 14px; width: auto;"
                      />
                    </b-button>
                  </div>
                </b-row>
              </template>

              <!-- SHOW Payment result status -->
              <template v-else>
                <div class="d-flex flex-column align-items-center">
                  <b-alert
                    :variant="paymentReceivedResult.variant"
                    class="col-9 col-md-12 text-center"
                    show
                  >
                    <p class="h1 mb-2">
                      <b-icon
                        :icon="
                          paymentReceiveSuccess
                            ? 'check-circle-fill'
                            : 'exclamation-circle-fill'
                        "
                      ></b-icon>
                    </p>
                    <h5 class="alert-heading">
                      {{ paymentReceivedResult.message }}
                      <div
                        class="row justify-content-center"
                        v-if="
                          paymentReceiveIsPending && nonUserOrderWalletAddress
                        "
                      >
                        <b-icon
                          icon="three-dots"
                          animation="cylon"
                          font-scale="4"
                        ></b-icon>
                      </div>
                      <div
                        v-if="
                          paymentReceiveIsPending && nonUserOrderWalletAddress
                        "
                        class="flex flex-column"
                      >
                        <p class="font-weight-bold text-dark">
                          The QR code will be invalid after 30 minutes.
                        </p>
                        <TimerComponent @onExpired="onTimerExpired" />
                      </div>
                    </h5>
                  </b-alert>
                  <div
                    class="d-flex flex-column align-items-center col-9 col-md-12 text-center justify-content-center"
                    v-if="
                      (paymentReceiveSuccess || paymentReceiveIsPending) &&
                        nonUserOrderWalletAddress
                    "
                  >
                    <div class="non-mcm-user-qrcode-wrapper mb-3">
                      <qrcode-vue
                        :value="nonUserOrderWalletAddress"
                        :size="175"
                        level="H"
                      />
                    </div>
                    <div class="qr-warning" v-if="paymentReceiveIsPending">
                      <p
                        v-html="
                          `<i class='fa fa-exclamation-triangle text-danger' style='font-size: 12px; margin-right: 3px;'></i>${qrWarningText}`
                        "
                      ></p>
                    </div>
                    <div class="my-4 d-flex non-user-wallet-address">
                      <h6
                        class="text-truncate text-break"
                        @click="onCopyText(nonUserOrderWalletAddress)"
                      >
                        {{ nonUserOrderWalletAddress }}
                      </h6>
                      <div
                        @click="onCopyText(nonUserOrderWalletAddress)"
                        class="ml-2"
                      >
                        <i class="fa fa-copy text-info fa-2x"></i>
                      </div>
                    </div>
                    <h4
                      class="font-weight-light mb-5"
                      v-if="nonUserOrderWalletNetworkName"
                    >
                      {{ $t("COMMON.network") }}:
                      <strong>{{ nonUserOrderWalletNetworkName }}</strong>
                    </h4>
                    <h4
                      class="font-weight-light"
                      v-if="getNonMcmTransactionAmount"
                    >
                      {{
                        $t(
                          "PAGES.SALES_MANAGEMENT.QR_SALE.ORDER_CRYPTO_AMOUNT_IS"
                        )
                      }}:
                      <strong>{{ getNonMcmTransactionAmount }}</strong>
                    </h4>
                  </div>
                  <div
                    v-if="notEnoughPayment"
                    class="d-flex flex-column align-items-center col-9 col-md-12 text-center justify-content-center pt-4"
                  >
                    <h4
                      class="font-weight-light mb-5"
                      v-if="getNonMcmDiffPrice"
                    >
                      {{ $t("missing_transaction_amount") }}:
                      <strong>{{ getNonMcmDiffPrice }}</strong>
                    </h4>
                    <h4
                      class="font-weight-light mb-5"
                      v-if="getNonMcmDiffAmount"
                    >
                      {{ $t("missing_crypto_amount") }}:
                      <strong>{{ getNonMcmDiffAmount }}</strong>
                    </h4>
                    <div class="d-flex align-items-center h4 mt-5">
                      <i
                        class="fa fa-exclamation-triangle text-danger"
                        style="margin-right: 3px;"
                      ></i>
                      {{ $t("pay_sdk_missing_payment_warning") }}
                    </div>
                    <div
                      class="d-flex align-items-center h4 mt-1"
                      v-if="
                        getInsufficientPaymentStateExtraInfoTextFromQueryParam
                      "
                    >
                      {{
                        getInsufficientPaymentStateExtraInfoTextFromQueryParam
                      }}
                    </div>
                  </div>
                </div>
                <div
                  class="row justify-content-center"
                  v-if="paymentReceiveSuccess"
                >
                  <b-button
                    pill
                    variant="primary"
                    class="mt-5"
                    style="min-width: 50%;"
                    @click.prevent="onClickSuccessOK"
                    size="lg"
                  >
                    <b-icon
                      font-scale="1.5"
                      icon="check"
                      aria-hidden="true"
                    ></b-icon>
                    {{ $t("FORM.OK") }}
                  </b-button>
                </div>
                <div
                  class="row justify-content-center"
                  v-if="notEnoughPayment || incorrectCurrency"
                >
                  <b-button
                    pill
                    variant="info"
                    class="mt-5"
                    style="min-width: 40%;"
                    @click.prevent="
                      notEnoughPayment
                        ? onInsufficientOK()
                        : onIncorrectCurrencyOK()
                    "
                    size="lg"
                  >
                    {{ $t("FORM.OK") }}
                  </b-button>
                </div>
              </template>
            </template>
          </div>
        </template>
      </b-col>
      <b-col></b-col>
    </b-row>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import mpayApi from "../services/api";
import mcmApi from "../services/apiOfinans";
import CurrencySelector from "../components/currency/CurrencySelector.vue";
import i18n from "../plugins/vue-i18n";
import TimerComponent from "../components/common/TimerComponent";
import wsService from "../services/mpay-ws";

const validateEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export default {
  name: "PaySdk",
  components: {
    CurrencySelector,
    QrcodeVue,
    TimerComponent
  },
  data() {
    return {
      errorMessage: null,
      isLoading: false,
      parentId: null,
      orderCreating: false,
      createdOrder: null,
      paymentUnitsLoading: false,
      paymentUnits: null,
      selectedPaymentUnit: null,
      cryptosLoading: false,
      cryptos: null,
      selectedCrypto: null,
      convertedCryptoAmount: null,
      nonUserOrderWalletAddress: null,
      nonUserOrderWalletNetworkName: null,
      paymentCreating: false,
      showPaymentResultSection: false,
      paymentReceivedResult: {
        variant: "warning",
        message: ""
      },
      notEnoughPayment: false,
      postMessageData: {
        token: "",
        order_price: ""
      },
      initEventLoading: true,
      incorrectCurrency: false
    };
  },
  computed: {
    accessToken() {
      return this.postMessageData.token;
    },
    orderPrice() {
      return this.postMessageData.order_price;
    },
    commissionPayerFromQueryParam() {
      return this.postMessageData?.commission_payer;
    },
    commissionPayer() {
      return this.commissionPayerFromQueryParam || "customer";
    },
    getPaymentUnitFromQueryParam() {
      return this.postMessageData?.payment_unit || null;
    },
    getCryptoFromQueryParam() {
      return this.postMessageData?.crypto || null;
    },
    getCustomerMail() {
      return this.postMessageData?.customer_email;
    },
    getCustomerName() {
      return this.postMessageData?.customer_name || "";
    },
    getCustomerPhone() {
      return this.postMessageData?.customer_phone || "";
    },
    theme() {
      const _themeFromQueryParam = this.postMessageData?.theme;
      if (
        !_themeFromQueryParam ||
        !["light", "dark"].includes(_themeFromQueryParam)
      ) {
        return "light";
      }
      return _themeFromQueryParam;
    },
    isDark() {
      return this.theme === "dark";
    },
    defaultAxiosConf() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    },
    createOrderForm() {
      return {
        customerMail: this.getCustomerMail,
        customerName: this.getCustomerName,
        customerPhone: this.getCustomerPhone,
        devicesId: 2, // 1:pos, 2:virtual pos, 3:web, 4: woocommerce
        feeIncluded: this.commissionPayer === "branch" ? true : false, // if true the BRANCH will pay the commission else the CUSTOMER
        price: `${this.orderPrice}`,
        integration_type: "js_sdk"
      };
    },
    getOrderId() {
      return this.createdOrder?.id
        ? this.createdOrder.id
        : this.createdOrder?._id;
    },
    getOrderNumber() {
      return this.createdOrder?.orderNumber || null;
    },
    getOrderAmount() {
      return this.createdOrder?.amount || null;
    },
    getPrice() {
      return this.createdOrder?.price || null;
    },
    getFee() {
      return this.createdOrder?.fee || null;
    },
    feeAmount() {
      return this.createdOrder?.feeAmount || null;
    },
    totalAmount() {
      return this.createdOrder?.orderTotal || null;
    },
    totalQuantity() {
      return this.convertedCryptoAmount
        ? this.convertedCryptoAmount
        : this.getOrderAmount;
    },
    selectedCryptoCode() {
      return this.selectedCrypto?.wallet?.currencyCode || null;
    },
    selectedCryptoId() {
      return this.selectedCrypto?.id || null;
    },
    paymentReceiveSuccess() {
      return this.paymentReceivedResult.variant === "success";
    },
    getNonMcmTransactionAmount() {
      return `${this.createdOrder?.amount || ""} ${this.selectedCryptoCode}`;
    },
    showCustomerInfo() {
      return (
        this.createOrderForm.customerName ||
        this.createOrderForm.customerMail ||
        this.createOrderForm.customerPhone
      );
    },
    paymentReceiveIsPending() {
      return this.paymentReceivedResult?.variant === "warning";
    },
    qrWarningText() {
      return this.$t("paySdkQrWarning", {
        value: this.selectedCryptoCode?.toUpperCase()
      });
    },
    getAutoSubmitPayBtn() {
      return this.postMessageData?.auto_submit_pay_btn
        ? `${this.postMessageData.auto_submit_pay_btn}` === "true"
        : false;
    },
    getNonMcmDiffPrice() {
      return (
        this.createdOrder?.diffPrice &&
        `${this.createdOrder.diffPrice} ${this.selectedPaymentUnit}`
      );
    },
    getNonMcmDiffAmount() {
      return (
        this.createdOrder?.diffAmount &&
        `${
          this.createdOrder.diffAmount
        } ${this.selectedCryptoCode?.toUpperCase()}`
      );
    },
    theOrder() {
      return {
        ...this.createdOrder,
        nonUserOrderWalletAddress: this.nonUserOrderWalletAddress,
        nonUserOrderWalletNetworkName: this.nonUserOrderWalletNetworkName
      };
    },
    getInsufficientPaymentStateExtraInfoTextFromQueryParam() {
      return this.postMessageData?.insufficient_payment_state_extra_info_text;
    }
  },
  created() {
    window.addEventListener("message", this.handleInit);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleInit);
    // disconnect [WS]
    this.disconnectWS();
  },
  methods: {
    connectWS() {
      // connect [WS]
      wsService.connect();
      wsService.addMessageListener(this.handleWSMessage);
    },
    async handleInit(event) {
      if (event.data?.event && event.data.event === "init") {
        const {
          token,
          order_price,
          commission_payer = "customer",
          customer_email,
          theme = "light",
          payment_unit,
          locale
        } = event.data.data;
        // set locale
        let defaultLocale = "en";
        if (locale && ["en", "tr"].includes(locale)) {
          defaultLocale = locale;
        }
        i18n.locale = defaultLocale;
        // check theme
        if (theme && theme === "dark") {
          document.body.classList.add("bg-dark", "text-white");
        }

        this.errorMessage = null;
        // validation
        if (!token) {
          this.errorMessage = "Authentication Error!";
          return;
        }
        if (!order_price) {
          this.errorMessage = "Order Price must be present.";
          return;
        }
        if (!/^\d+(\.\d{1,2})?$/.test(order_price)) {
          this.errorMessage =
            "Order Price must be numeric and accepts max 2 digit.";
          return;
        }
        if (
          commission_payer &&
          !["branch", "customer"].includes(commission_payer)
        ) {
          this.errorMessage = "Commission Payer is invalid.";
          return;
        }
        if (
          payment_unit &&
          !["USD", "GBP", "TRY", "EUR"].includes(payment_unit.toUpperCase())
        ) {
          this.errorMessage = "Payment Unit is invalid.";
          return;
        }
        if (customer_email && !validateEmail(customer_email)) {
          this.errorMessage = "Customer Email is invalid.";
          return;
        }

        // set defaults
        this.selectedPaymentUnit = payment_unit || null;
        this.postMessageData = event.data.data;
        // show UI
        this.initEventLoading = false;

        // api calls
        await this.getMe();
        await this.createdOrderAction();
        await this.getPaymentUnits();

        // trigger auto submit for pay btn if conditions meet
        if (
          this.selectedCrypto &&
          this.selectedPaymentUnit &&
          this.getAutoSubmitPayBtn
        ) {
          await this.onClickNonMcmUser();
        }
        this.connectWS();
      }
      if (
        event.data?.event &&
        event.data.event === "delete-wallet" &&
        event?.data?.data
      ) {
        const getAddress = event.data.data;
        this.deleteNonMcmWalletAddress(getAddress);
      }
    },
    onSuccess() {
      window.parent.postMessage(
        {
          event: "onSuccess",
          data: this.theOrder
        },
        "*"
      );
    },
    onClickSuccessOK() {
      window.parent.postMessage(
        {
          event: "onClickSuccessOK"
        },
        "*"
      );
    },
    onError(message) {
      window.parent.postMessage(
        {
          event: "onError",
          data: message
        },
        "*"
      );
    },
    onInsufficientPayment() {
      window.parent.postMessage(
        {
          event: "onInsufficientPayment",
          data: this.theOrder
        },
        "*"
      );
    },
    onInsufficientOK() {
      window.parent.postMessage(
        {
          event: "onClickInsufficientOK"
        },
        "*"
      );
    },
    onIncorrectCurrency() {
      window.parent.postMessage(
        {
          event: "onIncorrectCurrency",
          data: this.theOrder
        },
        "*"
      );
    },
    onIncorrectCurrencyOK() {
      window.parent.postMessage(
        {
          event: "onClickIncorrectCurrencyOK"
        },
        "*"
      );
    },
    async getMe() {
      this.isLoading = true;
      try {
        const res = await mpayApi.get("/me", this.defaultAxiosConf);
        this.isLoading = false;
        const role = res.data?.userRole?.roleRank;
        const _parentId = res.data?.parent?.id;
        const isKycVerified = res.data?.documentState || false;
        if (!role || role !== "ROLE_BRANCH" || !_parentId || !isKycVerified) {
          this.errorMessage = "Authentication Error";
          throw "Authentication Error";
        }
        this.parentId = _parentId;

        const findCryptoFromQueryParam = await this.getCompanyWallets();
        if (this.getCryptoFromQueryParam) {
          if (!findCryptoFromQueryParam) {
            this.errorMessage = "Invalid crypto selected.";
            return;
          } else {
            this.selectedCrypto = findCryptoFromQueryParam;
          }
        }

        return res.data;
      } catch (error) {
        this.isLoading = false;
        this.errorMessage = "Authentication Error";
        throw error;
      }
    },
    async createdOrderAction() {
      this.orderCreating = true;
      try {
        const res = await mpayApi.post(
          "company-orders",
          this.createOrderForm,
          this.defaultAxiosConf
        );
        this.orderCreating = false;
        this.createdOrder = res.data;
        if (
          this.selectedPaymentUnit &&
          !!this.selectedCrypto &&
          !!this.totalAmount
        ) {
          this.convertCurrencyToCrypto({
            crypto: this.selectedCrypto.wallet.currencyCode,
            currency: this.selectedPaymentUnit
          });
        }
        return res;
      } catch (error) {
        this.orderCreating = false;
        this.errorMessage = "Order can not be created.";
        throw error;
      }
    },
    async getCompanyWallets() {
      this.cryptosLoading = true;
      try {
        const res = await mpayApi.get(
          `companies/${this.parentId}/company-wallets`,
          this.defaultAxiosConf
        );
        this.cryptosLoading = false;
        this.cryptos = res?.data || [];
        const findCryptoFromQueryParam = this.getCryptoFromQueryParam
          ? res.data?.find(
              val =>
                val.wallet.currencyCode.toUpperCase() ===
                this.getCryptoFromQueryParam.toUpperCase()
            )
          : null;
        return findCryptoFromQueryParam;
      } catch (error) {
        this.cryptosLoading = false;
        throw error;
      }
    },
    async getPaymentUnits() {
      this.paymentUnitsLoading = true;
      try {
        const resp = await mpayApi.get("payment-units", this.defaultAxiosConf);
        this.paymentUnits =
          resp?.data?.map(val => ({
            ...val,
            label: val.name.toUpperCase()
          })) || [];
        this.paymentUnitsLoading = false;
      } catch (error) {
        this.paymentUnitsLoading = false;
        throw error;
      }
    },
    onCryptoSelected(crypto) {
      this.selectedCrypto = crypto;
      if (!!crypto?.wallet?.currencyCode && this.selectedPaymentUnit) {
        this.convertCurrencyToCrypto({
          crypto: crypto.wallet.currencyCode,
          currency: this.selectedPaymentUnit
        });
      }
    },
    onChangePaymentUnit() {
      if (this.selectedPaymentUnit && !!this.selectedCrypto) {
        this.convertCurrencyToCrypto({
          crypto: this.selectedCrypto.wallet.currencyCode,
          currency: this.selectedPaymentUnit
        });
      }
    },
    async convertCurrencyToCrypto({ crypto, currency }) {
      try {
        const res = await mcmApi.post("miraclepay/convert-test", {
          crypto,
          currency,
          amount: this.totalAmount
        });
        this.convertedCryptoAmount = res.data?.crypto_amount || "";
      } catch (error) {
        // console.log(error.response?.data?.message || "");
      }
    },
    async onClickNonMcmUser() {
      this.showPaymentResultSection = true;
      this.paymentCreating = true;
      this.paymentReceivedResult = {
        variant: "warning",
        message: ""
      };
      try {
        const res = await mpayApi.get(
          `/nexus/create_payment/${this.selectedCryptoCode}/${this.getOrderId}/${this.selectedPaymentUnit}`,
          this.defaultAxiosConf
        );
        this.paymentCreating = false;
        if (!res.data?.address) {
          throw "wallet-address-not-found";
        }
        this.createdOrder = {
          ...this.createdOrder,
          amount: res.data?.amount || ""
        };
        this.paymentReceivedResult.message = this.$t(
          "PAGES.SALES_MANAGEMENT.QR_SALE.nexusCreatePaymentWarning"
        );
        this.nonUserOrderWalletAddress = res.data.address;
        this.nonUserOrderWalletNetworkName =
          res.data?.walletNetwork?.name || null;
        window.parent.postMessage(
          {
            event: "onGetNexusPaymentAddress",
            data: res.data.address
          },
          "*"
        );
      } catch (error) {
        this.paymentCreating = false;
        this.paymentReceivedResult.variant = "danger";
        const errMessageKey =
          error === "wallet-address-not-found"
            ? "PAGES.SALES_MANAGEMENT.QR_SALE.active_wallet_address_not_found_please_try_again_later"
            : "PAGES.SALES_MANAGEMENT.LINK_SALES.TRANSACTION_ERROR";
        this.paymentReceivedResult.message = this.$t(errMessageKey);
        this.onError(this.$t(errMessageKey));
        // disconnect [WS]
        this.disconnectWS();
        throw error;
      }
    },
    handleWSMessage(message) {
      // _____message______
      // order_id
      // orderNumber
      // status
      // nexusAmount
      // nexusAmountConvertCurrency
      // amount
      // diffPrice
      // diffAmount

      if (this.getOrderId && `${this.getOrderId}` === `${message.order_id}`) {
        this.checkOrderStatus({
          nexusAmount: message?.nexusAmount || null,
          nexusAmountConvertCurrency:
            message?.nexusAmountConvertCurrency || null,
          amount: message?.amount || null,
          diffPrice: message?.diffPrice || null,
          diffAmount: message?.diffAmount || null,
          status: message?.status || 0
        });
      }
    },
    checkOrderStatus(order) {
      const { status } = order;
      this.createdOrder = { ...this.createdOrder, ...order };
      const isCompleted = `${status}` === "1";
      const insufficientPayment = `${status}` === "5";
      const isIncorrectCurrency = `${status}` === "50";
      if (isCompleted || insufficientPayment || isIncorrectCurrency) {
        if (this.nonUserOrderWalletAddress) {
          this.deleteNonMcmWalletAddress(this.nonUserOrderWalletAddress);
        }
        if (isCompleted) {
          this.onSuccess();
          this.paymentReceivedResult.variant = "success";
          this.paymentReceivedResult.message = this.$t(
            "PAGES.SALES_MANAGEMENT.LINK_SALES.TRANSACTION_SUCCESS"
          );
        } else if (insufficientPayment) {
          this.notEnoughPayment = true;
          this.onInsufficientPayment();
          this.paymentReceivedResult.variant = "info";
          this.paymentReceivedResult.message = this.$t(
            "PAGES.SALES_MANAGEMENT.QR_SALE.MISSING_ORDER_PAYMENT"
          );
        } else {
          this.incorrectCurrency = true;
          this.onIncorrectCurrency();
          this.paymentReceivedResult.variant = "danger";
          this.paymentReceivedResult.message = this.$t(
            "wrong_currency_status_desc"
          );
        }
      }
    },
    async deleteNonMcmWalletAddress(address) {
      await mpayApi.post(
        "delete-wallet-address",
        { address },
        this.defaultAxiosConf
      );
      window.parent.postMessage(
        {
          event: "onDeleteWalletSuccess"
        },
        "*"
      );
    },
    onTimerExpired() {
      if (this.nonUserOrderWalletAddress) {
        this.deleteNonMcmWalletAddress(this.nonUserOrderWalletAddress);
      }
      this.paymentReceivedResult.variant = "danger";
      this.paymentReceivedResult.message = "Your QR code has been expired.";
      // disconnect [WS]
      this.disconnectWS();
    },
    onCopyText(text) {
      window.parent.postMessage(
        {
          event: "onCopyWalletAddress",
          data: text || ""
        },
        "*"
      );
    },
    disconnectWS() {
      wsService.removeMessageListener(this.handleWSMessage);
      wsService.disconnect();
    }
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  max-height: 35px;
  width: auto;
}
.non-mcm-user-qrcode-wrapper {
  display: flex;
  justify-content: center;
  padding: 25px;
  border-radius: 5px;
  background: #fff;
}
.non-user-wallet-address {
  h6 {
    text-wrap: wrap;
  }
  div:hover {
    cursor: pointer;
    opacity: 0.7;
  }
}
.qr-warning {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #52525b;
  align-items: center;
  justify-content: center;
}
</style>
